import {useState} from "react"

export const useAccordionItemBodyStatus = () => {
    const [hasEntered, setHasEntered] = useState<boolean>(false);
    return {hasEntered, onEnter: () => setHasEntered(true)};
}